import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    stake: 'Unstake',
    inputTokenLabel: 'Amount {token}',
    receiveLabel: 'You receive',
    exchangeRateLabel: 'Exchange rate',
    rateValues: '{input} = {output}',
  },
};
